import { useEffect } from 'react';
import { Chat } from 'stream-chat-react';

import { UserData, setOrganizerToken } from '@bizzabo/entities';
import ChatContext from './chatContext';
import useChatInstance from './useChatInstance';

type Props = {
    eventId: number;
    user: UserData;
    accountId: number;
    isOrganizer?: boolean;
    isJoinChannelAsync?: boolean;
};

const ChatProvider: React.FC<Props> = ({
    eventId,
    user,
    accountId,
    isOrganizer,
    isJoinChannelAsync,
    children,
}) => {
    const { initChat, client } = useChatInstance(eventId, user, accountId, isJoinChannelAsync);

    useEffect(() => {
        if (isOrganizer) {
            setOrganizerToken();
            initChat();
        }
    }, []);

    let innerElement = children;

    if (client) {
        innerElement = (
            <Chat client={client} theme="demo">
                {children}
            </Chat>
        );
    } else if (isOrganizer) {
        return <div />;
    }

    return <ChatContext.Provider value={initChat}>{innerElement}</ChatContext.Provider>;
};

export default ChatProvider;
